import { render, staticRenderFns } from "./AddEventLocation.vue?vue&type=template&id=ed7889bc&"
import script from "./AddEventLocation.vue?vue&type=script&lang=js&"
export * from "./AddEventLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventLocation.vue"
export default component.exports